<template>
	<div class="review_detail">
		<div class="review_title">课题变更申请审批</div>
		<el-row>
			<el-col :span="12" class="table_header">变更前</el-col>
			<el-col :span="12" class="table_header">变更后</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="12">
				<div class="item">
					<div class="label">课题名称：</div>
					<div class="value">{{topicInfo.oldDeclareName}}</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="item">
					<div class="label">新课题名称：</div>
					<div class="value">{{topicInfo.newDeclareName}}</div>
				</div>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="12">
				<div class="item">
					<div class="label">课题负责人：</div>
					<div class="value">{{topicInfo.oldOneEmceeName}}</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="item">
					<div class="label">新课题负责人：</div>
					<div class="value">{{topicInfo.newOneEmceeName}}</div>
				</div>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="12">
				<div class="item">
					<div class="label">第二负责人：</div>
					<div class="value">{{topicInfo.oldTwoEmceeName}}</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="item">
					<div class="label">新第二负责人：</div>
					<div class="value">{{topicInfo.newTwoEmceeName}}</div>
				</div>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="12">
				<div class="item">
					<div class="label">承担单位：</div>
					<div class="value">{{topicInfo.oldOneUnitName}}</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="item">
					<div class="label">新承担单位：</div>
					<div class="value">{{topicInfo.newOneUnitName}}</div>
				</div>
			</el-col>
		</el-row>
		<el-row class="row">
			<el-col :span="12">
				<div class="item">
					<div class="label">申请延期：</div>
					<div class="value">{{topicInfo.oldExpectedClosingTime}}</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="item">
					<div class="label">延期时间：</div>
					<div class="value">{{topicInfo.month}}</div>
				</div>
			</el-col>
		</el-row>
		<el-row class="row">
			<div class="item">
				<div class="label">申请说明：</div>
				<div class="value">{{topicInfo.note}}</div>
			</div>
		</el-row>
		<el-row class="row">
			<div class="item">
				<div class="label">变更扫描件：</div>
				<div class="value">
					<el-image fit="scale-down" style="height: 80px;width: 80px;" :src="`${uploadUrl}/upload/download?id=${topicInfo.annexId}&openStyle=1`"  :preview-src-list="[`${uploadUrl}/upload/download?id=${topicInfo.annexId}&openStyle=1`]"></el-image>
				</div>
			</div>
		</el-row>
		<el-row class="row">
			<!-- 审核意见列表 -->
			<div class="list" v-if="Object.keys(topicInfo).length!==0 && topicInfo.auditList.length !==0">
				<div class="comments-list" v-for="(item, index) in topicInfo.auditList" :key="index">
					<div class="form-group row mb-2">
						<label class="col-md-2 col-12 col-form-label" style="text-align: right;">{{getReviewTitle(item.auditType,index+1)}}</label>
						<div class="col-md-9 col-10">
							<table class="table table-bordered table-centered mb-0">
								<tbody>
									<tr>
										<th>审核意见</th>
										<td>{{item.auditState == 0?'退回修改':item.auditState == 1?'通过':'不通过'}}</td>
										<th>审核人</th>
										<td>{{item.auditName}}</td>
										<th>审核时间</th>
										<td>{{item.createTime}}</td>
									</tr>
									<tr>
										<th>审核说明</th>
										<td colspan="5">{{item.auditExplain}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-md-1 col-2"><span class="required"></span></div>
					</div>
				</div>
			</div>
		</el-row>
		<el-form :model="reviewForm" :rules="rules" ref="reviewForm" label-width="100px" class="demo-reviewForm">
			<el-row>
				<el-form-item label="审核意见:" prop="auditState">
				  <el-radio-group v-model="reviewForm.auditState" @change="radioChange">
						<el-radio :label="true">通过</el-radio>
						<el-radio :label="false">不通过</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="审核描述:" prop="auditExplain">
				  <el-input type="textarea" :rows="2" v-model="reviewForm.auditExplain"></el-input>
				</el-form-item>
			</el-row>
		</el-form>
		<div class="btn_wrap">
			<el-button type="primary" @click="submitReview">确定</el-button>
			<el-button type="primary" @click="$emit('goBack')">返回</el-button>
		</div>
		
	</div>
</template>

<script>
	import { getReviewDetailById, schoolReviewOrAreaReview } from '@/api/after/topicManage.js';
	export default {
		props:{
			topicChangeRecordId:{
				type:Number|String,
				default:0
			},
			reviewType:{
				type:Number,
				default:0//类型(0:学校审,1:区审)
			}
		},
		data() {
			return {
				reviewForm: {
					alterationId:this.topicChangeRecordId,//课题变更id			
					auditType:this.reviewType,//审核类型（0：校审,1:区审）			
					auditState:'',//审核状态			
					// auditId:'',//审核人id			
					// auditName:'',//审核人名称			
					auditExplain:'',//审核说明
				},
				rules:{
					auditState:[{required:true,message:'请选择审核意见',trigger:'change'}],
					auditExplain:[{required:true,message:'请输入审核描述',trigger:'blur'}],
				},
				topicInfo:{},//课题信息
			}
		},
		computed:{
			// 获取评审意见标题
			getReviewTitle(auditType,index){
				return (auditType,index) => {
					if (auditType==0) {
						return '校审意见'+index
					}else{
						return '区审意见'+index
					}
				}
			}
		},
		created() {
			if (this.topicChangeRecordId) {
				this.getReviewDetailById()
			}else{
				this.$message.error('参数错误!')
				this.$emit('goBack')
			}
		},
		methods: {
			// 提交审核
			submitReview(){
				console.log('审核参数',this.reviewForm);
				this.$refs.reviewForm.validate(async valid => {
					if (valid) {
						const res = await schoolReviewOrAreaReview(this.reviewForm)
						if (res.code == 200) {
							this.$message.success('审核成功！')
							this.$emit('goBack')
						}else{
							this.$message.error(res.data)
						}
					}
				})
			},
			// 单选控制审核描述的必填
			radioChange(e){
				console.log(e);
				if (e === false) {
					this.rules.auditExplain[0].required = true
				}else{
					this.rules.auditExplain[0].required = false
				}
			},
			// 获取审核详情
			async getReviewDetailById() {
				const res = await getReviewDetailById(this.topicChangeRecordId)
				if (res.code == 200) {
					console.log('获取评审详情',res);
					if (!res.data.auditList) {
						res.data.auditList = []
					}
					this.topicInfo = res.data
				}else{
					this.$message.error(res.data)
				}
			}
		},
	}
</script>

<style scoped lang="scss">
	.list{
		width: 100%;
	}
	.btn_wrap{
		text-align: center;
	}
	::v-deep .row{
		margin: 0;
		min-height: 40px;
		display: flex;
		align-items: center;
		border-left: 1px solid #cfe6fb;
		border-right: 1px solid #cfe6fb;
		border-bottom: 1px solid #cfe6fb;
	}
	.review_title{
		background-color: #1b7bb3;
		color: #fff;
		height: 30px;
		line-height: 30px;
		margin-bottom: 20px;
		padding-left: 20px;
	}
	.table_header{
		background-color: #d0e4f5;
		color: #398fc1;
		text-align: center;
		height: 40px;
		line-height: 40px;
	}
.item{
	display: flex;
	align-items: center;
	padding-left: 10px;
	.label{
		color: red;
		width: 100px;
		text-align: right;
	}
	.value{
		
	}
}
</style>